import { Row, Col, Container, utils } from '@everlywell/leaves';
import React from 'react';
import { IEHSImage } from 'utils/types';

import SectionWrapper from '../../SectionWrapper';
import * as S from './styles';

export interface IEndToEndSection {
  headline: string;
  backgroundColor?: string;
  slug: string;
  steps: Array<{
    image?: IEHSImage;
    text: string;
  }>;
  blurbs: Array<{
    headline: string;
    text: string;
  }>;
}

export const EndToEndSection: React.FC<IEndToEndSection> = ({
  headline,
  backgroundColor,
  slug,
  steps,
  blurbs,
}) => (
  <SectionWrapper
    data-testid="endToEndSection"
    id={slug}
    backgroundColor={backgroundColor}
  >
    <Container>
      <Row>
        <Col xs={12}>
          <S.Headline>{headline}</S.Headline>
          <S.StepsWrapper>
            {steps.map((step) => (
              <S.Step key={utils.generateKey()}>
                {step.image ? (
                  <S.Image
                    image={step.image.gatsbyImageData}
                    alt={step.image.title}
                  />
                ) : null}
                <S.Text>{step.text}</S.Text>
              </S.Step>
            ))}
          </S.StepsWrapper>
          {blurbs.map((blurb) => (
            <S.Blurb key={utils.generateKey()}>
              <S.BlurbTitle>{blurb.headline}</S.BlurbTitle>
              <S.Text>{blurb.text}</S.Text>
            </S.Blurb>
          ))}
        </Col>
      </Row>
    </Container>
  </SectionWrapper>
);

export default EndToEndSection;
